import React from 'react';
import {
  Avatar,
  TimeAgo,
  ButtonSquare,
  Dropdown,
  Icon,
  Tooltip,
  AvatarTooltipContent,
} from '../../../shared/ui';

import { IconMap } from '../../../shared/sprite';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { TableCell, TableRow } from '../../../shared/ui/TableV2';
import { Snippet } from '@distribute/shared/types';

import { useSnippetAction } from '../hooks';
import { formatSnippetType } from '../lib';

import { SnippetCardRowPreview } from '../../../entities/snippets';

type Props = {
  snippet: Snippet;
};

export const SnippetRow: React.FC<Props> = ({ snippet }) => {
  const { handlePreviewSnippet, snippetOptions } = useSnippetAction({
    snippet,
  });

  return (
    <TableRow onClick={() => handlePreviewSnippet(snippet)}>
      <TableCell>
        <SnippetCardRowPreview snippet={snippet} />
      </TableCell>
      <TableCell>{formatSnippetType(snippet.type)}</TableCell>
      <TableCell>
        <TimeAgo datetime={snippet.createdAt} locale="my" />
      </TableCell>
      <TableCell>
        <div className="flex justify-start">
          <Tooltip
            sideOffset={4}
            className="px-3 py-2"
            hideArrow
            trigger={
              <Avatar
                className="border border-base-black/[0.08]"
                isUserAvatar
                displayName={snippet.owner?.displayName || ''}
                src={snippet.owner?.photoUrl}
                size="xs"
              />
            }
          >
            <AvatarTooltipContent
              displayName={snippet.owner?.displayName}
              email={snippet.owner?.email || ''}
            />
          </Tooltip>
        </div>
      </TableCell>
      <TableCell className="text-end">
        <div onClick={(e) => e.stopPropagation()}>
          <Dropdown
            listStyles="shadow-lg w-45"
            triggerComponent={
              <DropdownMenu.Trigger className="focus:outline-none">
                <ButtonSquare
                  size="sm"
                  variant="tertiary-gray"
                  className="w-8 h-8 rounded-lg"
                >
                  <Icon glyph={IconMap.DotsHorizontal} width={20} />
                </ButtonSquare>
              </DropdownMenu.Trigger>
            }
            items={snippetOptions}
          />
        </div>
      </TableCell>
    </TableRow>
  );
};
